import { Injectable } from '@angular/core';
import { HttpClient,HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  url = environment.apiUrl;

  constructor(
    private http:HttpClient
  ) { }

  // add users
  addUser(UserModal:any){
    return this.http.post<any>(this.url+'Login/Adduser',UserModal)
  }

  // Get All Users
  getAllUsers():Observable<any>{
    return this.http.get<any>(this.url+'Login/GetAllUser')
  }

  // Delete User
  deleteUser(id:any):Observable<any>{
    return this.http.get(this.url+'login/DeleteUser?userid='+id, {responseType:'text'})
  }

  // Username Already Exists
  userExist(username:any){
    return this.http.get<any>(this.url+'login/IsUserExists?username='+username)
  }

  // activate/deactivate user
  activeDeactivate(id:any, status:any){
    return this.http.get(this.url+'login/ActiveDeactive_user?id='+id+'&status='+status,{ responseType:'text'})
  }

  // phone number id,waba id -- user details from meta
  userMetaDetails(userMetaRegModal:any){
    return this.http.post(this.url+'Login/AddUserAccDetails',userMetaRegModal,{responseType:'text'})
  }

  // credit 
  getUserwiseCredit(userId:any):Observable<any>{
    return this.http.get<any>(this.url+'whatsapp/GetAvailableCredits?UserId='+userId)
  }

  // add credit
  addUserwiseCredit(UserId:number, Credits:number,servicetype:any){
    return this.http.post(this.url+'whatsapp/AssignCredits?UserId='+UserId+'&Credits='+Credits+'&servicetype='+servicetype,{UserId,Credits,servicetype})
  }

  // change password
  changePassword(UserName:any, OldPassword:any, NewPassword:any){
    return this.http.post(this.url+'Login/ChangeUserPassword?UserName='+UserName+'&OldPassword='+OldPassword+'&NewPassword='+NewPassword,{UserName,OldPassword,NewPassword})
  }

  // add rcs setting
  addRCSSetting(settingModal:any){
    return this.http.post(this.url+'rcs/AddRcsUser',settingModal)
  }

  //add jio rcs setting
  addJioRCSSetting(rcsJioModal:any){
    return this.http.post(this.url+'rcs/AddUserApiKey',rcsJioModal)
  }

  // get jio rcs setting
  getJioRCSSetting(UserId:any){
    return this.http.get<any>(this.url+'rcs/GetApiKeyByUserId?userid='+UserId)
  }

  //system traffic
  getSystemTraffic(Type:any){
    debugger;
    return this.http.get<any>(this.url+'WhatsApp/SystemTraficAllCampaign?Type='+Type)
  }

}
